import React, { useState, useEffect, useMemo, useRef } from 'react';
import './assests/css/style.css';
import imgurl from './assests/images/imgurl';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal'
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import AlertComp from './Alert';
import { useSelector, useDispatch } from 'react-redux'
import { setcountrycode, setmobnum, setidentasmale, setgender } from './Reducers/reducer'
import { Card, CardContent, Checkbox, Drawer, Select, Link } from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import i18next from 'i18next';
import LanguageSelector from './LanguageSelector';
import codes from 'country-calling-code'
import ReactCountryFlag from 'react-country-flag';
import { setLanguage } from './Redux/languageSlice';
import MobileHeader from './components/MobileHeader';
import { gTagTracking, trackEvent } from './utils/UtilityFunctions';
import { Check } from '@mui/icons-material';
import HtmlContentMaster from './utils/HtmlContentMaster';


function LoginPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [countryCode, setCountryCode] = useState('34');
    const [phoneno, setPhoneno] = useState('')
    const locale = useSelector((state) => state.language.langData);
    const [alertopen, setalertopen] = useState(false)
    const [alertmsg, setalertmsg] = useState('Test')
    const [modalopen, setModalOpen] = useState(false);
    const [genderchk, setgenderchk] = useState('Yes')
    const [lang, setLang] = useState('')
    const [errorMssg, setErrorMssg] = useState("");
    const [euCodes, setEuCodes] = useState([])
    const [isMobile, setIsMobile] = useState(false);
    const [open, setOpen] = useState(false);
    const [consentchk, setconsentchk] = useState(false);
    const [mobileConsent, setMobileConsent] = useState(false);
    const [privacyDrawer, setPrivacyDrawer] = React.useState(false);
    const [countrySearch, setCountrySearch] = useState('');
    const handleOpen = () => setModalOpen(true);
    const handleClose = () => setModalOpen(false);

    const countrycodeobj = {
      49: "DE",
      33: "FR",
      39: "IT",
      34: "ES",
      31: "NL",
      32: "BE",
      46: "SE",
      47: "NO",
      358: "FI",
      45: "DK",
      48: "PL",
      41: "CH",
      351: "PT",
      30: "GR",
      43: "AT",
      91: "IN",
    };

    const europeanCountryCodes = [
      'AT', // Austria
      'BE', // Belgium
      'BG', // Bulgaria
      'HR', // Croatia
      'CY', // Cyprus
      'CZ', // Czech Republic
      'DK', // Denmark
      'EE', // Estonia
      'FI', // Finland
      'FR', // France
      'DE', // Germany
      'GR', // Greece
      'HU', // Hungary
      'IE', // Ireland
      'IT', // Italy
      'LV', // Latvia
      'LT', // Lithuania
      'LU', // Luxembourg
      'MT', // Malta
      'NL', // Netherlands
      'PL', // Poland
      'PT', // Portugal
      'RO', // Romania
      'SK', // Slovakia
      'SI', // Slovenia
      'ES', // Spain
      'SE',  // Sweden
      // "CH", // Switzerland
      // "IN"
    ];

    useEffect(() => {
      if(!localStorage.getItem("country-code")){
        let defaultCountry = codes.find(c => c.isoCode2 === 'ES')
        localStorage.setItem('country-code', JSON.stringify(defaultCountry))
        checkCountryForCTA(defaultCountry)
      }
    }, [])

    useEffect(() => {
      if (!window.cordova) {
        let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
        if (!isMobile) {
          setIsMobile(false);
        } else {
          setIsMobile(true);
        }
      }
    }, [isMobile]);

    useEffect(() => {
      const euCallingCodes = codes.filter((c) => europeanCountryCodes.includes(c.isoCode2))      
      setEuCodes(codes)
    }, [europeanCountryCodes])

    // const inputRef = useRef(null);
    // useEffect(() => {
    //     const dialCode = inputRef.current?.querySelector('.special-label + div .flag-dropdown ~ input ~ div');
    //     if (dialCode) {
    //       dialCode.style.cursor = 'pointer';
    //       dialCode.onclick = () => {
    //         const flagDropdown = inputRef.current?.querySelector('.flag-dropdown');
    //         if (flagDropdown) flagDropdown.click(); // programmatically open the dropdown
    //       };
    //     }
    //   }, []);

    useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      console.log(searchParams);
      const langParam = searchParams.get("lang");

      if (langParam && ["en", "es", "fr"].includes(langParam)) {
        setLang(langParam);
        dispatch(setLanguage(langParam));
        i18next.changeLanguage(langParam);
        location.href = location?.href.split("?")[0];
      }

      const hash = window.location.hash; // "#/loginpage?gender=m"
      const queryString = hash.split('?')[1]; // "gender=m"

      const params = queryString?.split('=')[1]
      const gender = params
      if(gender && gender === "m"){
        localStorage.setItem('temp_gender', "male")
      } else if(gender && gender === "f"){
        localStorage.setItem('temp_gender', "female")
      }
      if(queryString){
        location.href = location?.href.split("?")[0];
      }
    }, [location, lang]);

    const profile = useSelector((state) => state.user.profile);

    const handleCountryCodeChange = (event) => {
      let countryCode = codes.filter((c) => c.countryCodes[0] === event.target.value)      
      dispatch(setcountrycode(countryCode[0].isoCode2));
      localStorage.setItem('country-code', JSON.stringify(countryCode[0]))
      setCountryCode(event.target.value);
      // localStorage.setItem('country-code', `+${event.target.value}`)
      checkCountryForCTA(countryCode[0])
    };

    // Check CTA for European countries
    const checkCountryForCTA = (countryData) => {
      const europeanCountryCodes = [
        'AT', // Austria
        'BE', // Belgium
        'BG', // Bulgaria
        'HR', // Croatia
        'CY', // Cyprus
        'CZ', // Czech Republic
        'DK', // Denmark
        'EE', // Estonia
        'FI', // Finland
        'FR', // France
        'DE', // Germany
        'GR', // Greece
        'HU', // Hungary
        'IE', // Ireland
        'IT', // Italy
        'LV', // Latvia
        'LT', // Lithuania
        'LU', // Luxembourg
        'MT', // Malta
        'NL', // Netherlands
        'PL', // Poland
        'PT', // Portugal
        'RO', // Romania
        'SK', // Slovakia
        'SI', // Slovenia
        'ES', // Spain
        'SE',  // Sweden
        // "CH", // Switzerland
        // "IN"
      ];
      if(europeanCountryCodes.includes(countryData.isoCode2)){
        // Show CTA for European countries
        localStorage.setItem('show_eu_cta', true)
      } else {
        localStorage.setItem('show_eu_cta', false)
      }
    }

    async function getotp() {
      // navigate('/otppage')

      if (phoneno != "") {
        let data = JSON.stringify({
          user_no: countryCode + phoneno,
        });

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://aloxa.ai/flaskservice/getotp",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
        try {
          const response = await axios.request(config);
          console.log("OTP API response", response.data);
          localStorage.setItem("phno", JSON.parse(data).user_no);
          dispatch(setmobnum("+" + countryCode + phoneno));
          // Call your tracking event with required values
          await trackEvent("user_requested_code", "success", '', countryCode + phoneno);
          await gTagTracking('user_requested_code', {
            action: 'success',
            error: '',
            mobile_number: localStorage.getItem('phno')
          })
          navigate("/otppage", { state: { from: "loginpage" } });
        } catch (error) {
          console.error("OTP API error", error);
          setalertmsg("Error sending OTP. Please check mobile number.");
          setalertopen(true);
          setTimeout(() => setalertopen(false), 4000);
          // Call tracking with error
          await trackEvent("user_requested_code", "fail", error.message, countryCode + phoneno);
          await gTagTracking('user_requested_code', {
            action: 'fail',
            error: error.message,
            mobile_number: localStorage.getItem('phno')
          })
        }
      } else {
        setalertmsg(i18next.t("Enter your mobile number"));
        setalertopen(true);
        setTimeout(() => {
          setalertopen(false);
        }, 4000);
      }
    }

    function checkGender(e) {
      console.log(e.target.value);
      setgenderchk(e.target.value);
      dispatch(setidentasmale(e.target.value));
      setTimeout(() => {
        e.target.value == "Yes" && setModalOpen(false);
      }, 1000);
    }

    const changeHandler = (value) => {
      setCountryCode(value);
    };

    const checkPhonenum = (event) => {
      const input = event.target.value;

      // Allow only digits
      if (!/^\d*$/.test(input)) {
        setErrorMssg("Only numeric characters are allowed.");
        return;
      }

      // Prevent input if it starts with 0
      if (input.length > 0 && input[0] === "0") {
        setErrorMssg(
          "Phone number should not begin with 0. Please enter a valid number."
        );
        return;
      }

      // Valid input
      setErrorMssg("");
      let addTenDigit = input.slice(0, 15);
      localStorage.setItem("phno", addTenDigit.slice(0, 15));
      setPhoneno(addTenDigit);
    };

    const handleEvent = async (event) => {
      try{
        await trackEvent(event, 'success', '', localStorage.getItem('phno'))  
        await gTagTracking(event, {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
      } catch(err) {
        console.log("err", err)  
        await trackEvent(event, 'fail', err, localStorage.getItem('phno')) 
        await gTagTracking(event, {
          action: 'fail',
          error: err,
          mobile_number: localStorage.getItem('phno')
        })  
      }  
    }

    const handleDrawer = (which, to) => {
      if (which === "privacy" && to === "open") {
        setPrivacyDrawer(true);
      } else if (which === "privacy" && to === "close") {
        setPrivacyDrawer(false);
      } else if (which === "terms" && to === "open") {
        setTermsDrawer(true);
      } else if (which === "terms" && to === "close") {
        setTermsDrawer(false);
      }
    };

    const toggleCheckBox = async (val) => {
      try {
        setconsentchk(!consentchk)
        if(val){
          await trackEvent('consent_given', 'success', '', localStorage.getItem('phno'))  
          await gTagTracking('consent_given', {
            action: 'success',
            error: '',
            mobile_number: localStorage.getItem('phno'),
          })
        }
      } catch (err) {
        console.log("err", err);
        await trackEvent('consent_given', 'fail', err, localStorage.getItem('phno')) 
        await gTagTracking('consent_given', {
          action: 'fail',
          error: err,
          mobile_number: localStorage.getItem('phno'),
        })
      }
    }

    // const checkConsent = () => {
    //   if(consentchk && mobileConsent && phoneno) {
    //     getotp()
    //   } else if (!consentchk && mobileConsent && phoneno) {
    //     setalertmsg("Please agree to our terms and conditions.");
    //     setalertopen(true);
    //     setTimeout(() => {
    //       setalertopen(false);
    //     }, 4000);
    //   } else if (consentchk && !mobileConsent && phoneno) {
    //     setalertmsg("Please agree to receive service updates and reminders on mobile number");
    //     setalertopen(true);
    //     setTimeout(() => {
    //       setalertopen(false);
    //     }, 4000);
    //   } else if (!consentchk && !mobileConsent && !phoneno) {
    //     setalertmsg("Please agree");
    //     setalertopen(true);
    //     setTimeout(() => {
    //       setalertopen(false);
    //     }, 4000);
    //   }
    // }

    const checkConsent = async () => {
      if (!phoneno) {
        setalertmsg("Please enter your mobile number.");
      } else if (!phoneno && !mobileConsent) {
        setalertmsg("Please agree to our terms and enter mobile number.");
      } else if (!consentchk) {
        setalertmsg("Please agree to our terms and conditions.");
      } 
      // else if (!mobileConsent) {
      //   setalertmsg("Please agree to receive service updates and reminders on your mobile number.");
      // } 
      else {
        if(mobileConsent) {
          await trackEvent('mobile_consent_given', 'success', '', localStorage.getItem('phno'))  
          await gTagTracking('mobile_consent_given', {
            action: 'success',
            error: '',
            mobile_number: localStorage.getItem('phno'),
          })  
        } 
        getotp();
        return; // stop here if successful
      }

      // Show alert if no return
      setalertopen(true);
      setTimeout(() => {
        setalertopen(false);
      }, 4000);
    };

    const countryDropdownOpened = async () => {
      const userObj = JSON.parse(localStorage.getItem('user_obj'))
      await trackEvent("country_dropdown_opened", "success", '', localStorage.getItem('phno'));
      await gTagTracking('country_dropdown_opened', {
        action: 'success',
        error: '',
        mobile_number: localStorage.getItem('phno'),
      })
    }

    // Filter countries based on search term
    const filteredCountries = useMemo(() => {
      if (!countrySearch.trim()) {
        return euCodes;
      }

      const searchLower = countrySearch.toLowerCase().trim();
      return euCodes.filter((country) => {
        const countryName = country.country.toLowerCase();
        const countryCode = country.countryCodes[0].toString();

        // Match by country name or calling code (with or without +)
        return countryName.includes(searchLower) ||
               countryCode.includes(searchLower) ||
               (`+${countryCode}`).includes(searchLower);
      });
    }, [euCodes, countrySearch]);

    return (
      <div className="loginpage">
        {/* <div className="loginbgimg toppg">
            </div> */}
        <div className="">
          {/* <div className="loginpglogo">
                    <img src={imgurl.logo1} alt="Alopexia Logo" />
                </div> */}
          {/* <div className="loginpgtext">
                    <p>SIGN IN WITH MOBILE NO.</p>
                </div> */}
          {/* {
            isMobile && 
              <React.Fragment>
                <div className="loginbackbtn">
                  <div className="d-flex justify-content-start align-items-center gobackbtn">
                    <span
                      className="backButtonDiv"
                      onClick={() => navigate("/", { replace: true })}
                    >
                      <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
                    </span>
                  </div>
                </div>
              </React.Fragment>
          } */}
          {/* <div
            className={
              window.cordova ? "language-select-div" : "language-select-div web"
            }
          >
            <LanguageSelector from={"Loginpage"} />
            {isMobile && <MobileHeader showDrawer={true}/>}
          </div> */}

          <Card className="otpcard loginpginput">
            <CardContent className="pb-16px d-flex align-items-center justify-content-center flex-direction-column">
              {
                isMobile && 
                  <div className="loginpglogo mt-5px">
                    <img src={imgurl.hairlossaiLogo} alt="New Logo" className='mainlogo'/>
                  </div>
              }
              <div className="otppgtext">
                <p>{i18next.t("To Sign In, Please Enter Your Mobile Number")}</p>
              </div>

              <Grid container spacing={0} className="otptextfield">
                <Grid item xs={12}>
                  <Select
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                    className="country-select countryDropdown"
                    disableUnderline={true}
                    onBlur={() => countryDropdownOpened()}
                    onOpen={() => setCountrySearch('')}
                    MenuProps={{
                      autoFocus: false,
                      PaperProps: {
                        style: {
                          maxHeight: 400,
                        },
                      },
                    }}
                  >
                    <MenuItem
                      disableRipple
                      onKeyDown={(e) => e.stopPropagation()}
                      style={{
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        zIndex: 1,
                        paddingTop: '12px',
                        paddingBottom: '12px',
                        borderBottom: '1px solid #e0e0e0'
                      }}
                    >
                      <TextField
                        autoFocus
                        placeholder={i18next.t("Search country or code...")}
                        fullWidth
                        size="small"
                        value={countrySearch}
                        onChange={(e) => setCountrySearch(e.target.value)}
                        onKeyDown={(e) => {
                          e.stopPropagation();
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </MenuItem>
                    {filteredCountries.map((o, i) => {
                      return (
                        <MenuItem value={o.countryCodes[0]} key={i}>
                          <ReactCountryFlag
                            className="countryFlags countryimage"
                            countryCode={o.isoCode2}
                            svg
                          />
                          {o.country + " " + "(+" + o.countryCodes[0] + ")"}
                        </MenuItem>
                      );
                    })}
                    {filteredCountries.length === 0 && (
                      <MenuItem disabled style={{ justifyContent: 'center' }}>
                        {i18next.t("No countries found")}
                      </MenuItem>
                    )}
                  </Select>
                </Grid>
                <Grid item xs={12} className="mt-20px">
                  <TextField
                    value={phoneno}
                    id="outlined-basic"
                    type="text"
                    label=""
                    variant="outlined"
                    placeholder={i18next.t("Enter your mobile number")}
                    className="whitefield"
                    onChange={(e) => {
                      checkPhonenum(e);
                      // let number = e.target.value
                      // localStorage.setItem('phno', number.slice(0,10))
                      // setPhoneno(number.slice(0,10))
                    }}
                  />
                </Grid>
              </Grid>
              {errorMssg ? (
                <div className="phoneNoErrorMessage">
                  {i18next.t(errorMssg)}
                </div>
              ) : (
                ""
              )}

              <div className='d-flex align-items-start justify-content-start flex-direction-column w-90 mr-20px ml-10px'>
                <div className="mt-20px checkBoxTerms">
                  <FormControlLabel
                    className="formConsent"
                    control={
                      <Checkbox
                        checked={consentchk}
                        onChange={(e) => toggleCheckBox(e.target.checked)}
                      />
                    }
                    label={
                      <>
                        {i18next.t("I agree to the")}{" "}
                        <Link
                          target="_blank"
                          className="linkText"
                          onClick={() => {
                            setOpen(true)
                            handleEvent('viewed_terms_of_use')
                          }}
                        >
                          {i18next.t("terms of use")}
                        </Link>
                        &nbsp; {i18next.t("and")} &nbsp;
                        <Link
                          target="_blank"
                          className="linkText"
                          onClick={() => {
                            handleDrawer("privacy", "open")
                            handleEvent('viewed_privacy_policy')
                          }}
                        >
                          {i18next.t("privacy policy.")}
                        </Link>
                      </>
                    }
                  />
                </div>

                <div className="mt-10px checkBoxTerms mobileConsentDiv">
                  <FormControlLabel
                    className="formConsent"
                    control={
                      <Checkbox
                        checked={mobileConsent}
                        onChange={(e) => setMobileConsent(e.target.checked)}
                      />
                    }
                    label={
                      <>
                        {i18next.t("I agree to receive doctor's comments, updates, and reminders on my mobile number.")}{" "}
                      </>
                    }
                  />
                </div>
              </div>


              {/* <p className="phnodisclaimer">
                <span>{i18next.t("Note")}</span>:{" "}
                {i18next.t(
                  "I agree to receive service updates and reminders on my mobile number"
                )}.
              </p> */}

              <Button
                variant="contained"
                className="commonButton mt-30px"
                onClick={() => checkConsent()}
              >
                {i18next.t("Proceed")}
              </Button>
            </CardContent>
          </Card>

          {/* {
            isMobile &&
              <div className='showWhatsapp' 
                onClick={() => {
                  let url = locale === "en" ?
                              "https://tinyurl.com/Aloxa-ai-English" 
                                :
                            locale === "es" ?
                              "https://tinyurl.com/Aloxa-ai-Spanish" 
                                :
                            locale === "fr" ?
                              "https://tinyurl.com/Aloxa-ai-Fren" 
                                :
                            "https://tinyurl.com/Aloxa-ai-English"
                  window.open(url, "_blank")
                }}
              >
                <p>Proceed via WhatsApp</p>
              </div>
          } */}

          {/* <div className="nextbtn">
                    <Button variant="contained" onClick={() => getotp()}>
                        <div className="nextbtntext loginpgtext">
                            <p> Request otp </p>
                            <img src={imgurl.arrows} alt="Forward arrows" />
                        </div>

                    </Button>
                </div> */}
        </div>
        {/* <div className='shapeblue'>
                <img src={imgurl.shapeblue} alt="Blue shape" />
            </div> */}
        <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
        <Drawer
          className="imguplddrwr trmscnddrwr"
          anchor={"bottom"}
          open={open}
          onClose={() => setOpen(false)}
        >
          <div className="drawerhead">
            <p></p>
            <div className="ellipse cursor-pointer" onClick={() => setOpen(false)}>
              <p>X</p>
            </div>
          </div>

          <div className="WordSection1">
            <h1>{i18next.t("Terms of Use")}</h1>

            <p className="MsoNormal">
              {i18next.t("Effective Date: 1 Jan, 2025")}
            </p>

            <h2>{i18next.t("Welcome")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Welcome to the Alopexia website and application! These Terms of Use (“Terms”) govern your use of the services (“Service”) provided by Centa Bio (“us,” “we,” or “our”). By accessing or using the Alopexia website and/or application, you agree to be bound by these Terms."
              )}{" "}
              <br></br>
              <br></br>
            </p>

            <p className="MsoNormal">
              {i18next.t(
                "If you disagree with any part of these Terms, you may not access the Service."
              )}
            </p>

            <h2>{i18next.t("1. Use of the Service")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Alopexia offers AI-driven personalized haircare solutions, including scalp assessment, treatment recommendations, and progress tracking. The Service is designed to provide actionable insights and personalized treatment options for users experiencing hair loss."
              )}
              <br></br>
              <br></br>
              {i18next.t("By using the Service, you agree to:")}
              <br></br>- {i18next.t("Use the Service only")}
              {i18next.t("for personal, non-commercial purposes.")}
              <br></br>- {i18next.t("Follow all")}
              {i18next.t(
                "applicable laws and regulations in your use of the Service."
              )}
            </p>

            <h2>{i18next.t("2. Eligibility")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "You must be at least 18 years old and a male to use the Service and capable of entering into a lawful agreement. By using the Service, you confirm that you meet these eligibility criteria."
              )}
            </p>

            <h2>{i18next.t("3. Account Creation")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Certain features may require you to create an account. You agree to:"
              )}
              <br></br>-{" "}
              {i18next.t(
                "Provide accurate and up-to-date information during registration."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Maintain the confidentiality of your account credentials."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Notify us immediately of any unauthorized access to your account."
              )}
              <br></br>
              <br></br>
              {i18next.t(
                "You are solely responsible for activities under your account."
              )}
            </p>

            <h2>{i18next.t("4. Acceptable Use")}</h2>

            <p className="MsoNormal">
              {i18next.t("When using the Service, you agree not to:")}
              <br></br>-{" "}
              {i18next.t(
                "Interfere with or disrupt the functionality of the Service."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Use the Service for illegal or unauthorized purposes."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Upload harmful content, such as viruses, worms, or other malicious software."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Engage in any activity that compromises the security or integrity of the Service."
              )}
            </p>

            <h2>{i18next.t("5. Intellectual Property Rights")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "All content, features, and functionality of the Service are the exclusive property of Centa Bio."
              )}{" "}
              <br></br>
              {i18next.t(
                "Unauthorized use of trademarks, logos, or proprietary materials is prohibited without prior written consent."
              )}
            </p>

            <h2>{i18next.t("6. Privacy")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Your use of the Service is governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information, including sensitive health data. Please review our Privacy Policy for more details."
              )}
            </p>

            <h2>{i18next.t("7. Data Usage and Sharing")}</h2>

            <p className="MsoNormal">
              {i18next.t("By using the Service, you agree to:")}
              <br></br>-{" "}
              {i18next.t(
                "Allow Centa Bio to collect and process data, including health-related data, to deliver personalized solutions."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Consent to data aggregation for research and service improvement."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Understand that we will not share your personally identifiable information without your explicit consent, except as required by law."
              )}
            </p>

            <h2>{i18next.t("8. Disclaimer of Warranties")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "The Service is provided on an “as is” and “as available” basis. Centa Bio does not guarantee uninterrupted access, error-free functionality, or the accuracy of the results generated by the AI-driven assessment."
              )}
            </p>

            <h2>{i18next.t("9. Limitation of Liability")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "To the fullest extent permitted by law, Centa Bio shall not be liable for:"
              )}
              <br></br>-{" "}
              {i18next.t("Indirect, incidental, or consequential damages.")}
              <br></br>-{" "}
              {i18next.t(
                "Loss of data, profits, or goodwill arising from your use of the Service."
              )}
            </p>

            <h2>{i18next.t("10. Changes to the Terms of Use")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "We reserve the right to update these Terms at any time. Any changes will be posted on this page, with the updated effective date. Continued use of the Service constitutes acceptance of the revised Terms."
              )}
            </p>

            <h2>{i18next.t("11. Governing Law")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "These Terms shall be governed by and construed in accordance with the laws of [Insert Governing Jurisdiction], without regard to its conflict of law principles."
              )}
            </p>

            <h2>{i18next.t("12. Contact Us")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "For questions or concerns regarding these Terms, please contact us at:"
              )}
              <br></br>- {i18next.t("Email")}: contact@alopexia.ai
              <br></br>- {i18next.t("Address")}: Centa Biotech SL,Alameda
              Principal 11,9001 Malaga, Spain.
              <br></br>
              {i18next.t(
                "By accessing or using the Alopexia website and application, you acknowledge that you have read, understood, and agree to these Terms of Use."
              )}
            </p>
          </div>
        </Drawer>
        <Modal
          open={modalopen}
          // onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="previewmodal loginmodal">
            <Grid xs={12} className="slide3gridtwo">
              <Grid xs={4}>
                <h2 className="question1 slide3">{"Are you a male?"}</h2>
              </Grid>

              <Grid xs={4}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  // defaultValue='Yes'
                  onChange={(e) => checkGender(e)}
                  className="modalradiobtns"
                >
                  <FormControlLabel
                    className="modalradiolabels"
                    control={
                      <Radio
                        icon={<CheckCircleOutlineIcon />}
                        checkedIcon={<CheckCircleIcon />}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 48,
                          },
                        }}
                      />
                    }
                    value="Yes"
                    label="Yes"
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        icon={<CheckCircleOutlineIcon />}
                        checkedIcon={<CheckCircleIcon />}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 48,
                          },
                        }}
                      />
                    }
                    value="No"
                    label="No"
                  />
                </RadioGroup>
                {genderchk == "No" && (
                  <h2 className="question1 slide3 sorrywrapper">
                    {"Sorry. This application is only for males."}
                  </h2>
                )}
              </Grid>
            </Grid>
          </Box>
        </Modal>
        <Drawer
          className="privacypolicydrawer"
          anchor={"bottom"}
          open={privacyDrawer}
          onClose={() => handleDrawer("privacy", "close")}
        >
          <div className="drawerhead">
            <div
              className="ellipse cursor-pointer"
              onClick={() => handleDrawer("privacy", "close")}
            >
              <p>X</p>
            </div>
          </div>
          <HtmlContentMaster keyName={"privacypolicy"} />
        </Drawer>
      </div>
    );
}

export default LoginPage;
